import ShowAfterFirstRender from '@/components/ShowAfterFirstRender'
import { HOST_URL } from '@/libs/constants'
import { PostType, RelevancesType } from '@/libs/types'
import { Utils } from '@/libs/Utils'
import clsx from 'clsx'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React from 'react'


type LinkShareType = {
    name: string
    slug: string
}

const Onshare: React.FC<LinkShareType & { title: string }> = ({ slug = "", title = "", name }) => {

    const handlerClick = () => {
        if (typeof window !== 'undefined') return [window.open(slug, title, 'height=450,width=550')]
        return false;
    }
    return (
        <span className={clsx("social__item rounded me-1", name)} onClick={handlerClick} />
    )
}

const Submenu: React.FC<{ locale: string, title: string, description: string, relevances: RelevancesType }> = ({
    locale,
    title = "",
    description = "",
    relevances }) => {
    const pathname = usePathname()

    const t = new Utils(locale).Translation

    const referrer = `${HOST_URL}${pathname}`

    const [linkeds, _] = React.useState<Array<LinkShareType>>([
        {
            name: 'facebook',
            slug: `https://www.facebook.com/sharer/sharer.php?t=${title}&u=${referrer}`
        }, {
            name: 'twitter',
            slug: `https://twitter.com/intent/tweet?text=${title}&via=${referrer}`
        }, {
            name: `linkedin`,
            slug: `https://www.linkedin.com/shareArticle?mini=true&title=${title}&summary=${description}&url=${referrer}`
        }
    ])

    return (
        <div className="pt-10 text-start">
            <ShowAfterFirstRender>
                <div className="socials mb-5">
                    <p className="h5 fw-light">Share</p>
                    <div className="mb-0">
                        {linkeds && linkeds.map((linked: LinkShareType, index: number) => {
                            return (
                                <Onshare key={index} {...linked} title={title} />
                            )
                        })}
                    </div>
                </div>
            </ShowAfterFirstRender>
            <div className="mb-5">
                <p className="h5 fw-light">{t("knowledges.related.post")}</p>
                {!!relevances && (
                    <div className="post__related mb-5">
                        {relevances.posts.data.map((post: PostType, index: number) => {
                            const { type, category, slug, title } = post.attributes
                            const isBlog = type === 'blogs'
                            const href = `/${locale}/${type}${isBlog ? "" : `/${category?.data?.attributes?.slug}`}/${slug.split(",").join("/")}`
                            return (
                                <Link passHref href={href} className="text-decoration-none mb-1" key={index}>
                                    {title}
                                </Link>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default Submenu